import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(err, t) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") {
    const translated = t ? t(`validation.${d}`) : d;
    if (translated !== `validation.${d}`) return translated;
    const authTranslated = t ? t(`auth.${d}`) : d;
    if (authTranslated !== `auth.${d}`) return authTranslated;
    return d;
  }
  if (Array.isArray(d)) return d.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return t ? t("common.error_generic") : "Error";
}

export default api;
